import { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import axios from "axios";
import { useLang } from "@/i18n/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterBox = () => {
  const { lang, T } = useLang();
  const B = T.blog;
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/newsletter/subscribe`, { email, lang });
      toast.success(res.data.already_subscribed ? B.nlAlready : B.nlSuccess);
      setEmail("");
    } catch {
      toast.error(B.nlError);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-orange-50 border border-orange-100 rounded-2xl p-8" data-testid="newsletter-box">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0">
          <Mail className="w-5 h-5 text-white" />
        </div>
        <h3 className="font-heading text-xl font-semibold text-slate-900">{B.nlTitle}</h3>
      </div>
      <p className="text-sm text-slate-600 mb-4">{B.nlText}</p>
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <Input
          type="email"
          required
          placeholder={B.nlPlaceholder}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="bg-white"
          data-testid="newsletter-email-input"
        />
        <Button
          type="submit"
          disabled={loading}
          className="bg-orange-500 hover:bg-orange-600 text-white font-semibold sm:px-8"
          data-testid="newsletter-submit-button"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : B.nlBtn}
        </Button>
      </form>
    </div>
  );
};
